/**
 * ObjectUI
 * Copyright (c) 2024-present ObjectStack Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/**
 * GENERATED FILE — do not edit by hand.
 *
 * Regenerate:  node scripts/regenerate-known-schema-types.mjs
 * Pinned by:   scripts/__tests__/known-schema-types-derivation-5115.test.ts
 *
 * Every component `type` this repository registers, as read out of the
 * registration calls themselves. `objectui check` uses it to decide whether a
 * schema's `type` names a component that exists.
 *
 * This list replaces a seventeen-entry array that was typed by hand into
 * `check.ts` and had drifted from the registry in both directions at once
 * (objectui#5115): it blessed `crud` and `gallery`, which nothing registers
 * and which render the OBJUI-001 "Unknown component type" panel, while
 * reporting 221 real bare keys — and every namespaced spelling, `view:grid`
 * included — as unknown. The header of the regeneration script carries the
 * measurements and explains why the CLI cannot simply ask `ComponentRegistry`.
 *
 * Both bare and namespaced spellings are present because both are real
 * registry keys: `register('grid', C, { namespace: 'view' })` stores
 * `view:grid` AND, unless `skipFallback` is set, bare `grid`.
 */

export const KNOWN_SCHEMA_TYPES: readonly string[] = [
  'a',
  'abbr',
  'accordion',
  'action:bar',
  'action:button',
  'action:group',
  'action:icon',
  'action:menu',
  'address',
  'advanced-chart',
  'ai-form-assist',
  'ai-recommendations',
  'ai:feedback',
  'ai:input',
  'ai:suggestion',
  'alert',
  'alert-dialog',
  'app',
  'app-creation-wizard',
  'app-schema-renderer',
  'app-shell:cloud-connection:panel',
  'app-shell:cloud:ai-model-status',
  'app-shell:cloud:onboarding-next',
  'app-shell:marketplace:installed-list',
  'app-shell:mcp:connect-agent',
  'app:launcher',
  'area-chart',
  'article',
  'aside',
  'aspect-ratio',
  'auto_number',
  'avatar',
  'b',
  'badge',
  'bar-chart',
  'blockquote',
  'boolean',
  'br',
  'branding-editor',
  'breadcrumb',
  'button',
  'button-group',
  'calendar',
  'calendar-view',
  'card',
  'carousel',
  'chart',
  'chart:bar',
  'chatbot',
  'chatbot-enhanced',
  'chatbot-floating',
  'checkbox',
  'checkboxes',
  'cite',
  'cloud-connection:panel',
  'cloud:ai-model-status',
  'cloud:onboarding-next',
  'code',
  'code-editor',
  'collapsible',
  'color',
  'combobox',
  'command',
  'container',
  'context-menu',
  'currency',
  'dashboard',
  'dashboard-editor',
  'dashboard-grid',
  'data-model-designer',
  'data-table',
  'date',
  'date-picker',
  'datetime',
  'dd',
  'del',
  'detail',
  'detail-section',
  'detail-view',
  'dialog',
  'div',
  'dl',
  'donut-chart',
  'drawer',
  'dropdown-menu',
  'dt',
  'element:button',
  'element:definition-list',
  'element:divider',
  'element:image',
  'element:metadata_viewer',
  'element:number',
  'element:record_picker',
  'element:repeater',
  'element:text',
  'element:text_input',
  'em',
  'email',
  'embeddable-form',
  'empty',
  'field-designer',
  'field:address',
  'field:audio',
  'field:auto_number',
  'field:avatar',
  'field:boolean',
  'field:checkboxes',
  'field:code',
  'field:color',
  'field:currency',
  'field:date',
  'field:datetime',
  'field:duration',
  'field:email',
  'field:file',
  'field:filter-condition',
  'field:formula',
  'field:geolocation',
  'field:grid',
  'field:html',
  'field:image',
  'field:json',
  'field:location',
  'field:lookup',
  'field:markdown',
  'field:master_detail',
  'field:multiselect',
  'field:number',
  'field:object',
  'field:object-ref',
  'field:password',
  'field:percent',
  'field:permission-facet-link',
  'field:phone',
  'field:progress',
  'field:qrcode',
  'field:radio',
  'field:rating',
  'field:recipient-picker',
  'field:richtext',
  'field:select',
  'field:signature',
  'field:slider',
  'field:summary',
  'field:tags',
  'field:text',
  'field:textarea',
  'field:time',
  'field:tree',
  'field:url',
  'field:user',
  'field:vector',
  'field:video',
  'figcaption',
  'figure',
  'file',
  'file-upload',
  'filter-builder',
  'filter-ui',
  'flex',
  'footer',
  'form',
  'form-analytics',
  'formula',
  'gantt',
  'geolocation',
  'global:notifications',
  'global:search',
  'grid',
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'header',
  'header-bar',
  'home',
  'hover-card',
  'hr',
  'html',
  'i',
  'icon',
  'image',
  'img',
  'import-wizard',
  'input',
  'input-otp',
  'ins',
  'kanban',
  'kanban-enhanced',
  'kanban-ui',
  'kbd',
  'label',
  'layout:app-schema-renderer',
  'layout:navigation-renderer',
  'layout:page-header',
  'layout:page:card',
  'layout:responsive-grid',
  'li',
  'line-chart',
  'list',
  'list-view',
  'loading',
  'location',
  'lookup',
  'main',
  'map',
  'mark',
  'markdown',
  'marketplace:installed-list',
  'master_detail',
  'mcp:connect-agent',
  'menubar',
  'metric',
  'metric-card',
  'multiselect',
  'nav',
  'nav:breadcrumb',
  'nav:menu',
  'navigation-designer',
  'navigation-menu',
  'navigation-renderer',
  'nl-query',
  'number',
  'object',
  'object-calendar',
  'object-chart',
  'object-data-table',
  'object-form',
  'object-gallery',
  'object-gantt',
  'object-grid',
  'object-kanban',
  'object-manager',
  'object-map',
  'object-master-detail-form',
  'object-metric',
  'object-pivot',
  'object-timeline',
  'object-tree',
  'object-view',
  'ol',
  'p',
  'page',
  'page-designer',
  'page-header',
  'page:accordion',
  'page:card',
  'page:footer',
  'page:header',
  'page:section',
  'page:sidebar',
  'page:tabs',
  'pagination',
  'password',
  'percent',
  'phone',
  'pie-chart',
  'pivot',
  'plugin-calendar:calendar-view',
  'plugin-calendar:object-calendar',
  'plugin-charts:advanced-chart',
  'plugin-charts:area-chart',
  'plugin-charts:bar-chart',
  'plugin-charts:chart',
  'plugin-charts:chart:bar',
  'plugin-charts:donut-chart',
  'plugin-charts:line-chart',
  'plugin-charts:object-chart',
  'plugin-charts:pie-chart',
  'plugin-charts:radar-chart',
  'plugin-charts:scatter-chart',
  'plugin-chatbot:chatbot',
  'plugin-chatbot:chatbot-enhanced',
  'plugin-chatbot:chatbot-floating',
  'plugin-dashboard:dashboard',
  'plugin-dashboard:dashboard-grid',
  'plugin-dashboard:metric',
  'plugin-dashboard:metric-card',
  'plugin-dashboard:object-data-table',
  'plugin-dashboard:object-metric',
  'plugin-dashboard:object-pivot',
  'plugin-dashboard:pivot',
  'plugin-designer:app-creation-wizard',
  'plugin-designer:branding-editor',
  'plugin-designer:dashboard-editor',
  'plugin-designer:data-model-designer',
  'plugin-designer:field-designer',
  'plugin-designer:navigation-designer',
  'plugin-designer:object-manager',
  'plugin-designer:page-designer',
  'plugin-designer:process-designer',
  'plugin-designer:report-designer',
  'plugin-detail:detail-section',
  'plugin-detail:detail-view',
  'plugin-detail:related-list',
  'plugin-editor:code-editor',
  'plugin-form:embeddable-form',
  'plugin-form:form-analytics',
  'plugin-form:object-form',
  'plugin-form:object-master-detail-form',
  'plugin-gantt:object-gantt',
  'plugin-grid:import-wizard',
  'plugin-grid:object-grid',
  'plugin-kanban:kanban-enhanced',
  'plugin-kanban:kanban-ui',
  'plugin-kanban:object-kanban',
  'plugin-list:list-view',
  'plugin-list:object-gallery',
  'plugin-map:object-map',
  'plugin-markdown:markdown',
  'plugin-report:report',
  'plugin-report:report-viewer',
  'plugin-report:spec-report',
  'plugin-timeline:object-timeline',
  'plugin-timeline:timeline',
  'plugin-tree:object-tree',
  'plugin-view:object-view',
  'plugin-view:view',
  'plugin-view:view:simple',
  'popover',
  'pre',
  'process-designer',
  'progress',
  'protocol-placeholder:ai:feedback',
  'protocol-placeholder:ai:input',
  'protocol-placeholder:ai:suggestion',
  'protocol-placeholder:app:launcher',
  'protocol-placeholder:field:address',
  'protocol-placeholder:field:audio',
  'protocol-placeholder:field:avatar',
  'protocol-placeholder:field:boolean',
  'protocol-placeholder:field:checkboxes',
  'protocol-placeholder:field:code',
  'protocol-placeholder:field:color',
  'protocol-placeholder:field:currency',
  'protocol-placeholder:field:date',
  'protocol-placeholder:field:datetime',
  'protocol-placeholder:field:duration',
  'protocol-placeholder:field:email',
  'protocol-placeholder:field:file',
  'protocol-placeholder:field:html',
  'protocol-placeholder:field:image',
  'protocol-placeholder:field:json',
  'protocol-placeholder:field:location',
  'protocol-placeholder:field:lookup',
  'protocol-placeholder:field:markdown',
  'protocol-placeholder:field:master_detail',
  'protocol-placeholder:field:multiselect',
  'protocol-placeholder:field:number',
  'protocol-placeholder:field:password',
  'protocol-placeholder:field:percent',
  'protocol-placeholder:field:phone',
  'protocol-placeholder:field:progress',
  'protocol-placeholder:field:qrcode',
  'protocol-placeholder:field:radio',
  'protocol-placeholder:field:rating',
  'protocol-placeholder:field:select',
  'protocol-placeholder:field:signature',
  'protocol-placeholder:field:slider',
  'protocol-placeholder:field:text',
  'protocol-placeholder:field:textarea',
  'protocol-placeholder:field:time',
  'protocol-placeholder:field:tree',
  'protocol-placeholder:field:url',
  'protocol-placeholder:field:video',
  'protocol-placeholder:global:notifications',
  'protocol-placeholder:global:search',
  'protocol-placeholder:nav:breadcrumb',
  'protocol-placeholder:nav:menu',
  'protocol-placeholder:page-header',
  'protocol-placeholder:page:accordion',
  'protocol-placeholder:page:card',
  'protocol-placeholder:page:footer',
  'protocol-placeholder:page:header',
  'protocol-placeholder:page:sidebar',
  'protocol-placeholder:page:tabs',
  'protocol-placeholder:record:activity',
  'protocol-placeholder:record:chatter',
  'protocol-placeholder:record:details',
  'protocol-placeholder:record:highlights',
  'protocol-placeholder:record:path',
  'protocol-placeholder:record:related_list',
  'protocol-placeholder:user:profile',
  'protocol-placeholder:view:calendar',
  'protocol-placeholder:view:drawer',
  'protocol-placeholder:view:gallery',
  'protocol-placeholder:view:gantt',
  'protocol-placeholder:view:grid',
  'protocol-placeholder:view:kanban',
  'protocol-placeholder:view:map',
  'protocol-placeholder:view:modal',
  'protocol-placeholder:view:simple',
  'protocol-placeholder:view:split',
  'protocol-placeholder:view:tabbed',
  'protocol-placeholder:view:timeline',
  'protocol-placeholder:view:wizard',
  'protocol-placeholder:widget:bar',
  'protocol-placeholder:widget:funnel',
  'protocol-placeholder:widget:heatmap',
  'protocol-placeholder:widget:image',
  'protocol-placeholder:widget:line',
  'protocol-placeholder:widget:metric',
  'protocol-placeholder:widget:pie',
  'protocol-placeholder:widget:pivot',
  'protocol-placeholder:widget:radar',
  'protocol-placeholder:widget:scatter',
  'protocol-placeholder:widget:table',
  'protocol-placeholder:widget:text',
  'q',
  'qrcode',
  'radar-chart',
  'radio',
  'radio-group',
  'rating',
  'record',
  'record:activity',
  'record:alert',
  'record:approvals',
  'record:attachments',
  'record:chatter',
  'record:details',
  'record:discussion',
  'record:highlights',
  'record:history',
  'record:line_items',
  'record:path',
  'record:quick_actions',
  'record:reference_rail',
  'record:related_list',
  'related-list',
  'report',
  'report-designer',
  'report-viewer',
  'report:report',
  'report:report-viewer',
  'report:spec-report',
  'resizable',
  'responsive-grid',
  'richtext',
  'scatter-chart',
  'scroll-area',
  'section',
  'select',
  'separator',
  'shared-view-link',
  'sheet',
  'sidebar',
  'sidebar-content',
  'sidebar-footer',
  'sidebar-group',
  'sidebar-header',
  'sidebar-inset',
  'sidebar-menu',
  'sidebar-menu-button',
  'sidebar-menu-item',
  'sidebar-provider',
  'sidebar-trigger',
  'signature',
  'skeleton',
  'slider',
  'small',
  'sonner',
  'sort-ui',
  'span',
  'spec-report',
  'spinner',
  'stack',
  'statistic',
  'strong',
  'sub',
  'summary',
  'sup',
  'switch',
  'table',
  'tabs',
  'tags',
  'text',
  'textarea',
  'time',
  'timeline',
  'toast',
  'toaster',
  'toggle',
  'toggle-group',
  'tooltip',
  'tree',
  'tree-view',
  'u',
  'ui:a',
  'ui:abbr',
  'ui:accordion',
  'ui:address',
  'ui:alert',
  'ui:alert-dialog',
  'ui:article',
  'ui:aside',
  'ui:aspect-ratio',
  'ui:avatar',
  'ui:b',
  'ui:badge',
  'ui:blockquote',
  'ui:br',
  'ui:breadcrumb',
  'ui:button',
  'ui:button-group',
  'ui:calendar',
  'ui:card',
  'ui:carousel',
  'ui:checkbox',
  'ui:cite',
  'ui:collapsible',
  'ui:combobox',
  'ui:command',
  'ui:container',
  'ui:context-menu',
  'ui:data-table',
  'ui:date-picker',
  'ui:dd',
  'ui:del',
  'ui:dialog',
  'ui:div',
  'ui:dl',
  'ui:drawer',
  'ui:dropdown-menu',
  'ui:dt',
  'ui:em',
  'ui:email',
  'ui:empty',
  'ui:figcaption',
  'ui:figure',
  'ui:file-upload',
  'ui:filter-builder',
  'ui:flex',
  'ui:footer',
  'ui:grid',
  'ui:h1',
  'ui:h2',
  'ui:h3',
  'ui:h4',
  'ui:h5',
  'ui:h6',
  'ui:header',
  'ui:header-bar',
  'ui:hover-card',
  'ui:hr',
  'ui:html',
  'ui:i',
  'ui:icon',
  'ui:image',
  'ui:img',
  'ui:input',
  'ui:input-otp',
  'ui:ins',
  'ui:kbd',
  'ui:label',
  'ui:li',
  'ui:list',
  'ui:loading',
  'ui:main',
  'ui:mark',
  'ui:menubar',
  'ui:nav',
  'ui:navigation-menu',
  'ui:ol',
  'ui:p',
  'ui:pagination',
  'ui:password',
  'ui:popover',
  'ui:pre',
  'ui:progress',
  'ui:q',
  'ui:radio-group',
  'ui:resizable',
  'ui:scroll-area',
  'ui:section',
  'ui:select',
  'ui:separator',
  'ui:sheet',
  'ui:sidebar',
  'ui:sidebar-content',
  'ui:sidebar-footer',
  'ui:sidebar-group',
  'ui:sidebar-header',
  'ui:sidebar-inset',
  'ui:sidebar-menu',
  'ui:sidebar-menu-button',
  'ui:sidebar-menu-item',
  'ui:sidebar-provider',
  'ui:sidebar-trigger',
  'ui:skeleton',
  'ui:slider',
  'ui:small',
  'ui:sonner',
  'ui:span',
  'ui:spinner',
  'ui:stack',
  'ui:statistic',
  'ui:strong',
  'ui:sub',
  'ui:sup',
  'ui:switch',
  'ui:table',
  'ui:tabs',
  'ui:text',
  'ui:textarea',
  'ui:time',
  'ui:toast',
  'ui:toaster',
  'ui:toggle',
  'ui:toggle-group',
  'ui:tooltip',
  'ui:tree-view',
  'ui:u',
  'ui:ul',
  'ul',
  'url',
  'user',
  'user:profile',
  'utility',
  'vector',
  'view',
  'view-switcher',
  'view:calendar',
  'view:chart',
  'view:dashboard',
  'view:detail',
  'view:drawer',
  'view:filter-ui',
  'view:form',
  'view:gallery',
  'view:gantt',
  'view:grid',
  'view:kanban',
  'view:list',
  'view:map',
  'view:modal',
  'view:shared-view-link',
  'view:simple',
  'view:sort-ui',
  'view:split',
  'view:tabbed',
  'view:timeline',
  'view:tree',
  'view:view-switcher',
  'view:wizard',
  'widget:bar',
  'widget:funnel',
  'widget:heatmap',
  'widget:image',
  'widget:line',
  'widget:metric',
  'widget:pie',
  'widget:pivot',
  'widget:radar',
  'widget:scatter',
  'widget:table',
  'widget:text',
];

const KNOWN_SCHEMA_TYPE_SET: ReadonlySet<string> = new Set(KNOWN_SCHEMA_TYPES);

/**
 * Does `type` name a component the ObjectUI stack registers?
 *
 * Answers about THIS repository's registrations only. A user project that
 * registers its own components will have keys this cannot know about, which is
 * why `objectui check` reports an unrecognised type as a warning and never
 * fails the run on it.
 */
export function isKnownSchemaType(type: string): boolean {
  return KNOWN_SCHEMA_TYPE_SET.has(type);
}
